"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendSetCookieHeaders = void 0;
const cookie_1 = require("../../utils/cookie");
const appendSetCookieHeaders = (headers, cookies, setCookieOptions) => {
    for (const { name, value } of cookies) {
        headers.append('Set-Cookie', (0, cookie_1.serializeCookie)(name, value, setCookieOptions));
    }
};
exports.appendSetCookieHeaders = appendSetCookieHeaders;
